import { Alert } from 'antd';
import styled, { css, FlattenSimpleInterpolation } from 'styled-components';

export const ScheduleBannerAlert = styled(Alert)`
  ${({ theme: { kcc } }): FlattenSimpleInterpolation => css`
    border: none;
    padding: ${kcc.padding.CONTENT_VERTICAL}px ${kcc.padding.CONTROL_HORIZONTAL}px;
    color: ${kcc.colors.TEXT};
    font-size: ${kcc.typography.FONT_SIZE.BASE}px;
    font-weight: ${kcc.typography.FONT_WEIGHT.EXTRA_BOLD};
    line-height: ${kcc.typography.LINE_HEIGHT.SM};
    background-color: ${kcc.colors.ORANGE[50]};
  `}
`;

export const IconContainer = styled.div`
  width: ${({ theme: { kcc } }): number => kcc.size.S300}px;
  height: ${({ theme: { kcc } }): number => kcc.size.S300}px;
`;
